// cache + batch fetcher for ticker -> company name
import api from "./api";

const cache = {}; // { "AAPL": "Apple Inc." }

export async function fetchNamesIfNeeded(symbols = []) {
    const ask = symbols
        .filter(Boolean)
        .map(s => s.toUpperCase())
        .filter((s, i, arr) => arr.indexOf(s) === i)
        .filter(s => cache[s] === undefined);

    if (ask.length === 0) return cache;

    try {
        const { data } = await api.post("/api/symbols/names", { tickers: ask });
        Object.entries(data || {}).forEach(([sym, name]) => (cache[sym] = name));
    } catch {
        // swallow; we'll just show tickers if names fail
    }
    return cache;
}

export function getCachedName(sym) {
    if (!sym) return undefined;
    return cache[sym.toUpperCase()];
}

